document.addEventListener('DOMContentLoaded', function () {
  const FREE_SHIPPING_THRESHOLD = window.themeSettings?.freeShippingThreshold || 50;
  
  function renderProgressBar(cart) {
    const container = document.getElementById('free-shipping-bar');
    if (!container) return;

    if (cart.items.length === 0) {
      container.style.display = 'none';
      return;
    }

    const total = cart.total_price / 100;
    const remaining = (FREE_SHIPPING_THRESHOLD - total).toFixed(2);
    const unlocked = total >= FREE_SHIPPING_THRESHOLD;
    const progress = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    
    container.innerHTML = `
      <div>
        <div style="width: ${progress}%;">
        </div>
        <span>${unlocked ? '🎉 You’ve unlocked free shipping!' : `You're £${remaining} away from free shipping!`}</span>
      </div>
    `;
  }

  function updateCartProgressBar() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(renderProgressBar);
  }

  updateCartProgressBar();

  // ✅ Respond to UpCart quantity or cart changes
  document.addEventListener('rebuy:cart.change', function () {
    setTimeout(updateCartProgressBar, 1000);
  });
  
});